import { tv } from 'tailwind-variants';

export const RevisionCardIcon = tv({
  base: 'text-md w-6',
  variants: {
    color: {
      interdisciplinar: 'text-interdisciplinar',
      redacao: 'text-redacao',
      literatura: 'text-literatura',
      espanhol: 'text-espanhol',
      ingles: 'text-ingles',
      portugues: 'text-portugues',
      gramatica: 'text-portugues',
      sociologia: 'text-sociologia',
      filosofia: 'text-filosofia',
      geografia: 'text-geografia',
      atualidades: 'text-atualidades',
      'bioquimica-superior': 'text-disciplina-bioquimica-superior',
      'anatomia-superior': 'text-disciplina-anatomia-humana-superior',
      'histologia-humana-superior':
        'text-disciplina-histologia-humana-superior',
      'fisiologia-superior': 'text-disciplina-fisiologia-humana-superior',
      'genetica-superior': 'text-disciplina-genetica-superior',
      'embriologia-superior': 'text-disciplina-embriologia-superior',
      'imunologia-superior': 'text-disciplina-imunologia-superior',
      'microbiologia-superior': 'text-disciplina-microbiologia-superior',
      'parasitologia-superior': 'text-disciplina-parasitologia-superior',
      'patologia-superior': 'text-disciplina-patologia-superior',
      'farmacologia-superior': 'text-disciplina-farmacologia-superior',
      historia: 'text-historia',
      matematica: 'text-matematica',
      fisica: 'text-fisica',
      quimica: 'text-quimica',
      biologia: 'text-biologia',
    },
  },
});
